module.exports = __webpack_public_path__ + "img/BETBOOM.4fed38ae.svg";